/**
 * plugins/chatwoot.js
 *
 * Dynamically injects the Chatwoot website widget SDK.
 * Only call this after third-party-cookie consent has been granted.
 */
import config from '@/config/config';

let chatwootLoaded = false;

export function loadChatwoot() {
  if (chatwootLoaded) return;
  chatwootLoaded = true;

  const { baseUrl, websiteToken } = config.chatwootConfig;
  window.chatwootSettings = {
    position: 'left'
  };
  const script = document.createElement('script');
  script.src = `${baseUrl}/packs/js/sdk.js`;
  script.async = true;
  script.onload = () => {
    window.chatwootSDK.run({
      websiteToken,
      baseUrl
    });
  };
  document.body.appendChild(script);
}
